import { Box, Flex, Table, Text, Tooltip } from '@radix-ui/themes';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import Icon from '~/components/Icon';
import OrderIcon from '~/components/Table/orderIcon';

const StyledFlex = styled(Flex)`
  ${props =>
    props.canOrder &&
    css`
      cursor: var(--cursor-button);
    `}
`;

function HeaderCell({ item, onChange, sortableArray, data, metaData }) {
  const theme = useTheme();
  const { headerRenderFunc, key, canOrder, tooltipText, label } = item;

  function checkListOfHeadersArrayDirection(key) {
    return sortableArray.find(item => item.key === key)?.direction ?? null;
  }

  const headerDirection = checkListOfHeadersArrayDirection(key);

  function toggleChange() {
    if (headerDirection === 'asc') return onChange(key, 'desc');
    if (headerDirection === 'desc') return onChange(key, null);
    onChange(key, 'asc');
  }

  return (
    <Table.ColumnHeaderCell key={item.key}>
      {headerRenderFunc ? (
        headerRenderFunc(data, metaData)
      ) : (
        <StyledFlex
          onClick={canOrder ? toggleChange : undefined}
          gap='2'
          align='center'
        >
          <Flex
            align='center'
            gap='2'
          >
            <Text
              color={headerDirection ? 'black' : 'gray'}
              wrap='nowrap'
            >
              {label}
            </Text>
          </Flex>
          {tooltipText && (
            <Tooltip content={tooltipText}>
              <Box>
                <Icon
                  name='information'
                  color={headerDirection ? theme.color.neutral[12] : theme.color.neutralAlpha[11]}
                  width={20}
                  height={20}
                />
              </Box>
            </Tooltip>
          )}
          {canOrder && <OrderIcon orderDirection={headerDirection} />}
        </StyledFlex>
      )}
    </Table.ColumnHeaderCell>
  );
}

HeaderCell.propTypes = {
  item: PropTypes.shape({
    key: PropTypes.string,
    headerRenderFunc: PropTypes.func,
    label: PropTypes.string,
    canOrder: PropTypes.bool,
    tooltipText: PropTypes.string,
  }),
  onChange: PropTypes.func,
  sortableArray: PropTypes.array,
  data: PropTypes.object,
  metaData: PropTypes.object,
};

export default HeaderCell;
